/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agents_Actor_AgentInputs */

const en_directory_agents_actor_agent = /** @type {(inputs: Directory_Agents_Actor_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent`)
};

const zh_directory_agents_actor_agent = /** @type {(inputs: Directory_Agents_Actor_AgentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent`)
};

/**
* | output |
* | --- |
* | "Agent" |
*
* @param {Directory_Agents_Actor_AgentInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agents_actor_agent = /** @type {((inputs?: Directory_Agents_Actor_AgentInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agents_Actor_AgentInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agents_actor_agent(inputs)
	return zh_directory_agents_actor_agent(inputs)
});
export { directory_agents_actor_agent as "directory.agents.actor_agent" }